import { z } from 'zod';
import { ValidationRules } from './validation-rules';

// OTP form schema - array of 6 individual digits
export const otpSchema = z.object({
  code: ValidationRules.otp,
});

// Type inference from schema
export type OtpFormData = z.infer<typeof otpSchema>;

// Default values - 6 empty strings
export const otpFormDefaults: OtpFormData = {
  code: ['', '', '', '', '', ''],
};
